import {
  type POBillToContactSystemPreference,
  type POBillToPrimaryCategorySystemPreference,
} from './SystemPreference'
import { POBillToContactModes } from '../enums/POBillToContactModeEnum'
import { POBillToPrimaryCategories } from '../enums/POBillToPrimaryCategoryEnum'

// What a tenant gets before either bill-to preference is saved, and what
// readers fall back to when a stored value cannot be interpreted.
export const DEFAULT_PO_BILL_TO_PRIMARY_CATEGORY: POBillToPrimaryCategorySystemPreference['value'] =
  POBillToPrimaryCategories.PURCHASER_HOME

export const DEFAULT_PO_BILL_TO_CONTACT: POBillToContactSystemPreference['value'] =
  {
    mode: POBillToContactModes.PURCHASER,
    userId: null,
  }
